import {IUiServices} from "@kta20-core/interfaces/i-ui-services";

export interface IUiBaseBridge {
    readonly uiService: IUiServices;
}

export const IUIBASE_BRIDGE = 'IUiBaseBridge';
